import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Snackbar, Alert } from '@mui/material';
import * as types from 'constants/actionTypes';

class CustomSnackbar extends Component {
    constructor(props) {
        super(props);
    }

    onClose = () => {
        this.props.closeSnackbar();
    }

    render() {
        const p = this.props;
        return (
            <div className="SnackBar">
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    sx={{
                        zIndex: 999999999,
                    }}
                    open={p.open}
                    autoHideDuration={8000}
                    onClose={() => this.onClose()}
                >

                    <Alert>{p.message}</Alert>
                </Snackbar>
            </div>);
    }
}

function mapStateToProps(state) {
    return {
        open: state.common.snackbar ? state.common.snackbar.open : false,
        message: state.common.snackbar ? state.common.snackbar.message : ""
    };
}

function mapDispatchToProps(dispatch) {
    return {
        closeSnackbar: () => dispatch({ type: types.SNACKBAR_HIDE_MESSAGE })
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomSnackbar);